import React, { useState } from 'react';
import { TextField, Stack } from '@mui/material';

const EditForm = ({
  name: initialName,
  description: initialDescription,
  loading: externalLoading,
}) => {
  const [name, setName] = useState(initialName || '');
  const [description, setDescription] = useState(initialDescription || '');

  return (
    <Stack direction='column' spacing={3} p={2}>
      <TextField
        label='Nombre'
        id='name'
        name='name'
        value={name}
        onChange={e => setName(e.target.value)}
        fullWidth
        required
        disabled={externalLoading}
        variant='outlined'
        helperText='Nombre del modelo anatómico'
      />

      <TextField
        label='Descripción'
        id='description'
        name='description'
        value={description}
        onChange={e => setDescription(e.target.value)}
        fullWidth
        multiline
        rows={6}
        disabled={externalLoading}
        variant='outlined'
        helperText='Descripción detallada del modelo anatómico'
      />
    </Stack>
  );
};

export default EditForm;
